export enum ActivityStreamEclPropertyType {
  ReviewedById = 'ReviewedById',
  ApprovedById = 'ApprovedById'
}
